export enum MatchingStrategy {
  ALL = 'ALL',
  ANY = 'ANY',
}

export enum MatchingOperator {
  EQUALS = 'equals',
  NOT_EQUALS = 'notEquals',
  IS_EMPTY = 'isEmpty',
  IS_NOT_EMPTY = 'isNotEmpty',
  INCLUDES_ONE = 'includesOne',
  EXCLUDES_ONE = 'excludesOne',
  INCLUDES_ALL = 'includesAll',
  EXCLUDES_ALL = 'excludesAll',
  LESS_THAN = 'lessThan',
  LESS_THAN_OR_EQUALS = 'lessThanOrEquals',
  GREATER_THAN = 'greaterThan',
  GREATER_THAN_OR_EQUALS = 'greaterThanOrEquals',
}

export enum MatchingDeprecatedType {
  FROM_NAME = 'fromName',
  FROM_EMAIL = 'fromEmail',
  FROM_NUMBER = 'fromNumber',
  TO_NUMBER = 'toNumber',
}

export enum MatchingConversationType {
  TAGS = 'conversationTags',
  QUEUE = 'conversationQueue',
  STATUS = 'conversationStatus', // 'open', 'closed', 'pending', 'awaitingpending'
  LANGUAGE = 'conversationLanguage', // ???
  AGENT_HAS_REPLIED = 'agentHasReplied',
  USER_HAS_REPLIED = 'userHasReplied',
  AGENT_HAS_REPLIED_TRIGGER = 'agentHasRepliedSinceTrigger',
  USER_HAS_REPLIED_TRIGGER = 'userHasRepliedSinceTrigger',
  CONVERSATION_HAS_BEEN_ASSIGNED = 'conversationHasBeenAssigned',
  TO = 'to',
  FROM = 'from',
  ALL_MESSAGES = 'allMessages',
  CONTACT_CUSTOM_ATTRIBUTES = 'contactCustomAttribute',
  CONVERSATION_CUSTOM_ATTRIBUTES = 'conversationCustomAttribute',
  DIRECTION = 'direction', // 'inbound', 'outbound'
  CHANNEL = 'channelId',
  CONVERSATION_RATING_SCORE = 'conversationRatingScore',
  CONVERSATION_RATING_COMMENT = 'conversationRatingComment',
}
export enum MatchingContactType {
  CONTACT_NAME = 'contactName',
  CONTACT_EMAIL = 'contactEmail',
  CONTACT_PHONE = 'contactPhone',
  CONTACT_FACEBOOK_ID = 'contactFacebookId',
  CONTACT_INSTAGRAM_USERNAME = 'contactInstagramUsername',
}

export enum MatchingTriggeringType {
  TRIGGERING_TAG = 'triggeringTag',
  TRIGGERING_CUSTOM_FIELD = 'triggeringCustomField',
}

export enum VariableScope {
  SYSTEM = 'system',
  INPUT = 'input',
  SCOPE = 'scope',
  // FLOW = 'flow', // 'flow' will be added later - maybe
}

export type VariableType =
  | MatchingDeprecatedType
  | MatchingConversationType
  | MatchingContactType
  | MatchingTriggeringType;

export type MatchVariableT = {
  scope: VariableScope;
  variableType: VariableType | string;
  id?: string;
};

type MatchValueValueFEAttribsDefaultT = { label: string };

export type MatchValueValueT<TFEAttribs = MatchValueValueFEAttribsDefaultT> = {
  value: string;
  meta: TFEAttribs;
};

export type MatchValueT<TFEAttribs = MatchValueValueFEAttribsDefaultT> = {
  scope: VariableScope;
  values: MatchValueValueT<TFEAttribs>[];
};

export type MatchingRuleT<TFEAttribs = MatchValueValueFEAttribsDefaultT> = {
  operator: MatchingOperator;
  variable: MatchVariableT;
  match: MatchValueT<TFEAttribs>;
};

export type MatchingRuleCondition = {
  operator: MatchingOperator;
  variable: MatchVariableT;
  match: {
    scope: VariableScope;
    values: string[];
  };
};

export enum TagOperation {
  TAG = 'tag',
  UNTAG = 'untag',
}

export type ConditionFormValuesT = {
  matchingStrategy: MatchingStrategy;
  rules: MatchingRuleT[];
};

/** Subset of matching types that are displayed as system variables when matching */
export const conditionSystemVariables = [
  MatchingConversationType.TO,
  MatchingConversationType.FROM,
  MatchingContactType.CONTACT_NAME,
  MatchingContactType.CONTACT_EMAIL,
  MatchingContactType.CONTACT_PHONE,
  MatchingContactType.CONTACT_FACEBOOK_ID,
  MatchingContactType.CONTACT_INSTAGRAM_USERNAME,
  MatchingConversationType.ALL_MESSAGES,
];
